<div class="section"  *ngIf="checkpolicy==undefined && checkleadership==undefined && checkownerpolicy==undefined && checkVideos ==undefined && checkPress == undefined && checkAwards == undefined && checkPrivacyPolicy == undefined && checkTermsOfUse == undefined">    
    <div class="container">
        <div class="col-md-12 content_title vision_title">
            <h1 style="font-size: 32px; text-align: center;" class="content-heading"> {{ title }} </h1>
        </div>
        <div class="content_body">
            <div class="row pol_content inner_content" style="font-size: 18px;" [ngStyle]="{'font-weight' : id == 3 ? '500' : '400'}"  [innerHTML]="content"></div>
        </div> 
    </div>
    <div class="container" style="margin-bottom: 40px;" *ngIf="checkAboutus == true">
        <div class="col-md-12 content_title about_title" style="margin-top: 0 !important;">
            <h1 style="font-size: 32px; text-align: center; " class="content-heading"> {{ aboutTitle }} </h1>
        </div>
        <div class="content_body about_content_body" style="margin-bottom: 0 !important;">
            <div class="row pol_content inner_content about_inner_content" [innerHTML]="aboutContent"></div>
        </div> 
    </div> 
</div>
<div class="section" *ngIf="checkPrivacyPolicy == true">
    <div class="container-fluid" >
        <div class="row policies_row_wrapper">
            <div class="col-md-3 policies" style="font-size: 16px;">
                <ul class="list-unstyled">
                    <div class="policies_list" [routerLink]="['/page',5,'Privacy Policy']">
                        <a class="tenant_policies">Privacy Policy</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',80,'Privacy Policy']">
                        <a class="tenant_policies">Commitment</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',79,'Privacy Policy']">
                        <a class="tenant_policies">Personal Information </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',82,'Privacy Policy']">
                        <a class="tenant_policies">  Non-Personal Information </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',83,'Privacy Policy']">
                        <a class="tenant_policies">  Cookies </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',84,'Privacy Policy']">
                        <a class="tenant_policies">  Session Data </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',85,'Privacy Policy']">
                        <a class="tenant_policies">  Others </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',86,'Privacy Policy']">
                        <a class="tenant_policies">  Promotional Initiatives </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',87,'Privacy Policy']">
                        <a class="tenant_policies">  Does YourOwnROOM protect my personal information </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',88,'Privacy Policy']">
                        <a class="tenant_policies">  Does YourOwnROOM secure the consent its user post from other users </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',89,'Privacy Policy']">
                        <a class="tenant_policies">  How does YourOwnROOM use the information that it collects </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',90,'Privacy Policy']">
                        <a class="tenant_policies">  Security Precautions </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',91,'Privacy Policy']">
                        <a class="tenant_policies">  Children Privacy </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',92,'Privacy Policy']">
                        <a class="tenant_policies">  Will YourOwnROOM change privacy policy in future</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',93,'Privacy Policy']">
                        <a class="tenant_policies">  Your Consent </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                </ul>
            </div>
            <div class="col-md-8 policy_content privacy_policy_content">
                <div class="col-md-12 content_title"  >
                    <h1 class="title_wrapper" style="font-family: Montserrat !important;">{{ title }}</h1>
                </div>
                <div [innerHTML]="content" style="font-size: 16px; line-height: 32px; font-family: Montserrat, sans-serif; margin-top: 40px;"></div>
            </div>
        </div>
    </div>
</div>
<div class="section" *ngIf="checkTermsOfUse == true">
    <div class="container-fluid" >
        <div class="row policies_row_wrapper">
            <div class="col-md-3 policies" style="font-size: 16px;">
                <ul class="list-unstyled">
                    <div class="policies_list" [routerLink]="['/page',9,'Terms of Use']">
                        <a class="tenant_policies">Terms of Use</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',94,'Terms of Use']">
                        <a class="tenant_policies">Introduction</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',95,'Terms of Use']">
                        <a class="tenant_policies">What information do we collect? </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',96,'Terms of Use']">
                        <a class="tenant_policies">  Eligibility </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',97,'Terms of Use']">
                        <a class="tenant_policies">  Subscription to service </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',98,'Terms of Use']">
                        <a class="tenant_policies">  Protection of login id and password </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',99,'Terms of Use']">
                        <a class="tenant_policies">  Stay connected </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',100,'Terms of Use']">
                        <a class="tenant_policies">  Internet traffic </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',101,'Terms of Use']">
                        <a class="tenant_policies">  Website content </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',102,'Terms of Use']">
                        <a class="tenant_policies">  User conduct </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',103,'Terms of Use']">
                        <a class="tenant_policies">  Intellectual property </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',105,'Terms of Use']">
                        <a class="tenant_policies">  Disclaimers - Website Content </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',106,'Terms of Use']">
                        <a class="tenant_policies">  Links to third party content </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',107,'Terms of Use']">
                        <a class="tenant_policies">  Property leads shared on non-exclusive basis</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',108,'Terms of Use']">
                        <a class="tenant_policies">  No warranty </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',109,'Terms of Use']">
                        <a class="tenant_policies">  Computer System/Mobile Application </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',110,'Terms of Use']">
                        <a class="tenant_policies">  Limitation of liability </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',111,'Terms of Use']">
                        <a class="tenant_policies">  Indemnity </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',113,'Terms of Use']">
                        <a class="tenant_policies">  Force majeaure </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',112,'Terms of Use']">
                        <a class="tenant_policies">  Disputes, governing law and jurisdiction </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',114,'Terms of Use']">
                        <a class="tenant_policies">  Termination </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',115,'Terms of Use']">
                        <a class="tenant_policies">  Disclaimers - Other terms </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',116,'Terms of Use']">
                        <a class="tenant_policies">  Contacting us </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                </ul>
            </div>
            <div class="col-md-8 policy_content privacy_policy_content">
                <div class="col-md-12 content_title"  >
                    <h1 class="title_wrapper" style="font-family: Montserrat !important;">{{ title }}</h1>
                </div>
                <div [innerHTML]="content" style="font-size: 16px; line-height: 32px; font-family: Montserrat, sans-serif; margin-top: 40px;"></div>
            </div>
        </div>
    </div>
</div>
<div class="section" *ngIf="checkpolicy!=undefined">
    <div class="container-fluid">
        <div class="row policies_row_wrapper">
            <div class="col-md-3 policies" style="font-size: 16px;">
                <div style="display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <h3 class="policies_title">Tenant Policies</h3>
                </div>
                <ul class="list-unstyled">
                    <div class="policies_list" [routerLink]="['/page',12,'Code of Conduct']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Code of Conduct</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',58,'Property Maintenance and Hygiene']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Property Maintenance and Hygiene</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',59,'Property Upkeep']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Property Upkeep</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',60,'Guest Policy']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Guest Policy </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',61,'Theft-Damage']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Theft & Damage </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',62,'Escalation Process']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Escalation Process </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',63,'Office Timings']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Office Timings </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',20,'Booking']" (click)="dispIntoView()">
                        <a class="tenant_policies">Booking</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',64,'Refund of Token & Booking amount']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Refund of Token & Booking amount</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',65,'Refund Details']" (click)="dispIntoView()" >
                        <a class="tenant_policies">Refund Details </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',21,'Security Deposit']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Security Deposit</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',27,'Move In']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Move In</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',28,'Lock In']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Lock In</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',15,'Rent']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Rent</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',38,'How to Pay Rent']" (click)="dispIntoView()">
                        <a  class="tenant_policies">How to Pay Rent</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',31,'Service Requests']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Service Requests</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',32,'Audit']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Audit</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',29,'Move Out']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Move Out | Notice</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',30,'Transfers and Reallocations']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Transfers and Reallocations</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',39,'Security deposit return terms']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Security deposit return terms</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',40,'Cancellation and Return Policy']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Cancellation and Return Policy</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',26,'Renewal of tenancy']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Renewal of tenancy</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',41,'Referral Bonus']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Referral Bonus</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',42,'Reimbursement to Tenants']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Reimbursement to Tenants</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',24,'Water Management']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Water Management</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',22,'Electricity Management']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Electricity Management</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',23,'Waste Management']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Waste Management</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',55,'Rate Card']" (click)="dispIntoView()">
                        <a  class="tenant_policies">Rate Card – Tenant</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                </ul> 
            </div>
            <div class="col-md-8 policy_content" >
                <div class="col-md-12 content_title"  >
                    <h1 class="title_wrapper">{{ title }}</h1>
                </div>
                <div id="disp_policies" [innerHTML]="content" style="font-size: 16px; line-height: 32px; padding: 0px 10px; font-family: Montserrat, sans-serif; margin-top: 40px;"></div>
            </div>
        </div>
    </div>
</div> 
<div class="section" *ngIf="checkleadership == true">
    <div class="container-fluid" >
        <div class="row policies_row_wrapper">
            <div class="col-md-3 policies" style="font-size: 16px;">
                <div style="display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <h3 class="policies_title">Our Leaders </h3>
                </div>
                <ul class="list-unstyled">
                    <div class="policies_list" [routerLink]="['/page',7,'Executive Officers']">
                        <a class="tenant_policies">Executive Officers</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',13,'Board of Directors']">
                        <a class="tenant_policies">Board of Directors </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',25,'Advisory Commitee']">
                        <a class="tenant_policies">  Advisory Commitee </a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                </ul>
            </div>
            <div class="col-md-8 policy_content leadership_content">
                <div class="col-md-12 content_title"  >
                    <h1 class="title_wrapper">{{ title }}</h1>
                </div>
                <div [innerHTML]="content" style="font-size: 16px;"></div>
            </div>
        </div>
    </div>
</div>
<div class="section" *ngIf="checkownerpolicy!=undefined">
    <div class="container-fluid">
        <div class="row policies_row_wrapper">
            <div class="col-md-3 policies" style="font-size: 16px;">
                <div style="display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <h3 class="policies_title">Owner Policies</h3>
                </div>
                <ul class="list-unstyled">
                    <div class="policies_list" [routerLink]="['/page',34,'Engaging Yourownroom']" (click)="dispIntoView()">
                        <a class="tenant_policies">Engaging Yourownroom</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',43,'Sign Lease deed_Service agreement']" (click)="dispIntoView()">
                        <a class="tenant_policies"> Sign Lease deed / Service agreement</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',44,'Approve Service Request resolution']" (click)="dispIntoView()">
                        <a class="tenant_policies">Approve Service Request resolution</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',45,'Furnish Property']" (click)="dispIntoView()">
                        <a class="tenant_policies">Furnish Property</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div> 
                    <div class="policies_list" [routerLink]="['/page',46,'Timely payment of Maintenance Charges']" (click)="dispIntoView()">
                        <a class="tenant_policies">Timely payment of Maintenance Charges</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',47,'Notify and Seek Approval from the Society']" (click)="dispIntoView()">
                        <a class="tenant_policies">Notify and Seek Approval from the Society</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',49,'Receive Rent']" (click)="dispIntoView()">
                        <a class="tenant_policies">Receive Rent</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',50,'View Owner Dash Board']" (click)="dispIntoView()">
                        <a class="tenant_policies">View Owner Dashboard</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',51,'Return of Security deposit']" (click)="dispIntoView()">
                        <a class="tenant_policies">Return of Security deposit</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',52,'Inform YourOwnROOM on updates and Complaints']" (click)="dispIntoView()">
                        <a class="tenant_policies">Inform YourOwnROOM on updates and Complaints</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',53,'Termination of Service']" (click)="dispIntoView()">
                        <a class="tenant_policies">Termination of Service</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',54,'Engaging Tenants post agreement']" (click)="dispIntoView()">
                        <a class="tenant_policies">Engaging Tenants post agreement</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',72,'Property Onboarding']" (click)="dispIntoView()">
                        <a class="tenant_policies">Property Onboarding</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',73,'Property Offboarding']" (click)="dispIntoView()">
                        <a class="tenant_policies">Property Offboarding</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                    <div class="policies_list" [routerLink]="['/page',56,'Rate Card']" (click)="dispIntoView()">
                        <a class="tenant_policies">Rate Card – Owners</a>
                        <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                    </div>
                </ul>
            </div>
            <div class="col-md-8 policy_content" id="disp_policies">
                <div class="col-md-12 content_title"  >
                    <h1 class="title_wrapper">{{ title }}</h1>
                </div>
                <div class="row pol_content" [innerHTML]="content" style="font-size: 16px;line-height: 32px; font-family: Montserrat, sans-serif; padding: 0px 20px; margin-top: 40px;"></div>
            </div>
        </div>
    </div>
</div>

<!-------------------------------------------- YOR Videos start here  ---------------------------------->
<div class="section" *ngIf="checkVideos !=undefined">
    <div class="video_bg">
        <div class="vid_img_wrapper">
            <h1 class="vid_top" style="font-family: 'Montserrat'; font-weight: 500; color: black;">Videos </h1>            
        </div>
    </div>
    
    <div class="container" id="video_section">
        <div class="row video_list">
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> YourOwnROOM's journey and Plans for 2024-25: Prabhat Kumar Tiwary, CEO, YourOwnRoom </h1>
                            <p class="vidTxt_detail"> Prabhat Kumar Tiwary, Founder, CEO and MD of YourOwnRoom in an interview</p>
                        </div>
                        <div class="video_month_wrapper" style="display: flex; justify-content: center;">
                            <p class="videos_month_text"> Aug'24 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <!-- <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/watch?v=2KKxRNMIB58" frameborder="0" allowfullscreen></iframe> -->
                <iframe width="560" height="315" src="https://www.youtube.com/embed/2KKxRNMIB58?si=-eUgFIdblUzZVTre" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/Up3rnhvvBKw" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Prabhat Tiwary's Entrepreneurial Journey with YourOwnROOM </h1>
                            <p class="vidTxt_detail"> In this session of IFSA talks, Kunal and Tushar from the IFSA BITS Pilani Chapter sits down with Prabhat Kumar Tiwary, the visionary founder, MD and CEO of YourOwnROOM </p>
                        </div>
                        <div class="video_month_wrapper" style="display: flex; justify-content: center;">
                            <p class="videos_month_text"> Jul'23 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row video_list">
            
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> The story of building YourOwnRoom: Prabhat Kumar Tiwary, CEO, YourOwnRoom </h1>
                            <p class="vidTxt_detail"> Prabhat Kumar Tiwary, Founder, CEO and MD of YourOwnRoom in an interview with PropertyBuzz </p>
                        </div>
                        <div class="video_month_wrapper" style="display: flex; justify-content: center;">
                            <p class="videos_month_text"> Jan'23 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/uKmvXDKwwos" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>

        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/R9-IKnIbY5c" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> How YourOwnRoom is building a Profitable & Scalable Proptech rental and property management business </h1>
                            <p class="vidTxt_detail"> Prabhat Kumar Tiwary, Founder, CEO and MD of YourOwnRoom in an exclusive interview... </p>
                        </div>
                        <div class="video_month_wrapper" style="display: flex; justify-content: center;">
                            <p class="videos_month_text"> Jan'23 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> PropertyWala’s session with CEO of YourOwnRoom </h1>
                            <p class="vidTxt_detail"> In this session, Deepika Gupta, Co-Founder of PropertyWala.com interacts with Prabhat Kumar Tiwary, CEO of YourOwnRoom, a residential real estate rental and property management company. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Nov'22 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/XUJf7Z7Ey3g" frameborder="0" allowfullscreen></iframe>
            </div>            
        </div>

        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/fknrquvWeRQ" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Operations and Technology are the Cornerstones of YourOwnROOM’s Growth - Sanjay Singh, COO & CTO </h1>
                            <p class="vidTxt_detail"> 2022-23 and beyond is all about Growth. We are on track to clock a revenue of 10 Crores. </p>
                        </div>
                        <div class="video_month_wrapper" style="display: flex; justify-content: center;">
                            <p class="videos_month_text"> Oct'22 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> 2022-23 Priorities and Plans : YourOwnROOM By Prabhat Kumar Tiwary – Founder & CEO </h1>
                            <p class="vidTxt_detail"> We just successfully concluded our 6th AGM at @YourOwnROOM. It has been a great journey so far and I am even more excited about what lies ahead.  </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Oct'22 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/xRgatZ1s1Bc" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/mj3CBhAo4SY" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> The Indian Dream - Prabhat K Tiwary </h1>
                            <p class="vidTxt_detail"> A conversation with Prabhat K Tiwary, Founder, CMD & CEO of YourOwnRoom </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jul'22 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> The future of living and the evolution of rentals: YourOwnRoom's Prabhat Kumar talks CoLiving & more </h1>
                            <p class="vidTxt_detail"> I am super thrilled to share a very engaging conversation with my good friend Vishal Krishna from UpStreamLife Media Pvt. Ltd ! Thoroughly enjoyed sharing my Journey, Residential Real estate market landscape and Future Growth Plans at YourOwnROOM </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jun'22 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/c9VCOcF2DIk" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/Me4GPZQyfEQ" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> How to make Real Estate customers fall in love with your brand? </h1>
                            <p class="vidTxt_detail"> I am happy to share my latest interaction with Digvijay Chauhan CBO of Totality powered by RealtyNXT on how #PropTech is changing the landscape of the Residential Real Estate! </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jun'22 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Prop-Tech is the New Growth Catalyst in Residential Real Estate? </h1>
                            <p class="vidTxt_detail"> YourOwnROOM, a Proptech Residential real estate asset management company with AUM of 1 Million sqft valued at 400 Crores… </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Apr'22 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/1Z9SgYZF8lg" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/rvcO1LfYqTo" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> 2022-23 Priorities and Plans : YourOwnROOM </h1>
                            <p class="vidTxt_detail"> 2022-23 is power-packed for us. Here's how we plan to transform our growth path and trajectory! See how you can be a part of this phenomenal projected growth. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Apr'22 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Top Trends in Residential Real Estate and PropTech </h1>
                            <p class="vidTxt_detail"> Sharing the latest from learnings and observations in this space. Watch video to learn more… </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Apr'22 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/u5GFLL9Ltbk" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/C6EtBzc_k84" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> 2021-22 Reflection </h1>
                            <p class="vidTxt_detail"> See how life at YourOwnROOM has been post pandemic. 2021-22 has been challenging but we’ve risen to the occasion to grow significantly. Learn more…</p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Apr'22 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Guts, Story & Glory</h1>
                            <p class="vidTxt_detail"> Join us in conversation with Alok Sinha and Sangam Surve as we discuss 
                                the adoption of technology as a residential asset</p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Nov'20 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/9qKlD5jmXMY" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px;" src="https://www.youtube.com/embed/WbeEmTskMw4" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> 2019-20 Reflection</h1>
                            <p class="vidTxt_detail"> It has been our 4th year of Operations and we are delighted to have built a very strong foundation on which we can profitably grow our business. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jul'20 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Stanford Club of India </h1>
                            <p class="vidTxt_detail"> We had the opportunity to share YourOwnROOM’s journey, learnings and Road map with the Stanford Alumni Indian Community. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> May'20 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/ch457kvODzU" frameborder="0" allowfullscreen></iframe>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/I4m2CFQVLYY" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> Backstage With Millionairs  </h1>
                            <p> Join us in another exciting interview as we share the YourOwnROOM story and the larger value proposition. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Dec'19 </p>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
        <div class="row video_list">
            
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> 2018-19 Reflection </h1>
                            <p> We’ve had a fantastic year in 2018-19 and we want to share this journey we call YourOwnROOM with all of you. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jan'19 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/FCEt7tGV74o" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>        
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/agHv4j3pZMs" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> What we learned from millennials </h1>
                            <p> Millennials are forecasted to be of prime importance to the success of new-age businesses. Get key insights in this video. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Jul'18 </p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="row video_list">
            <div class="vid_txt vid_txt_1">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleRight" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> YOR Founders' Story </h1>
                            <p> What’s the story behind YOR? Hear from the founders as they battle through the highly unorganized residential real-estate market. </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Aug'17 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/1ab8cHBgD0o" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>  
        <div class="row video_list">
            <div class="vid_cols">
                <iframe class="video-frames" style="width:100%;min-height:300px" src="https://www.youtube.com/embed/Uw5AU3WkRiY" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="vid_txt">
                <div class="video_desc">
                    <div>
                        <div class="angle_arrow">
                            <fa-icon [icon]="faAngleDoubleLeft" class="fa-5x" style="color: #a99173; font-family: 300;" ></fa-icon>
                        </div>
                        <div>
                            <h1 class="vidText_head"> YourStory Emerging Startups </h1>
                            <p> Ecstatic to feature and share the YourOwnROOM story with the Yourstory community! </p>
                        </div>
                        <div class="video_month_wrapper">
                            <p class="videos_month_text"> Feb'17 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</div>
<!-------------------------------------- YOR Videos ends here ------------------------------------>
<!--------------------------------------------- YOR in the News start here ----------------------------->
    <div *ngIf="checkPress == true">
        <div class="press_bg">        
            <div class="press_img_wrapper">
                <h1 class="press_top" style="font-family: 'Montserrat'; font-weight: 500; color: black;"> In the News </h1>
            </div>        
        </div>
        <div class="container image_container">
        <div id="accordion">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                  <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    2023-24
                  </button>
                </h5>
              </div>
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">                
                            <img src="assets/images/news/startup_news.png" style="width: 140px;">                    
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startupnews.fyi/2024/03/01/prop-tech-company-yourownroom-signs-partnership-deals-worth-6-millionwith-2-developers-to-secure-1000-residential-units-in-bangalore/" target="_blank">Prop-tech Company YourOwnROOM signs Partnership deals worth $6 Millionwith 2 Developers to secure 1,000 residential units in Bangalore!</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Mar 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/prop_tech_buzz.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://media.proptechbuzz.com/yourownroom-secures-6-million-bangalore-partnerships/" target="_blank">YourOwnROOM Secures $6 Million in Partnership Deals for 1,000 Residential Units in Bangalore</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">                
                            <img src="assets/images/news/startup-story.png" style="width: 140px;">                    
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startupstorymedia.com/insights-yourownroom-secures-6-million-partnership-deals-for-1000-residential-units-in-bangalore/" target="_blank">YourOwnROOM Secures $6 Million Partnership Deals for 1,000 Residential Units in Bangalore</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/bw_business_world.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://businessworld.in/article/yourownroom-seals-2-mn-deal-with-agser-buildtech-for-bangalore-projects-510751" target="_blank">YourOwnROOM Seals $2 Mn Deal With Agser BuildTech For Bangalore Projects</a>
                                    <span class="badge badge-pill badge-info m-2 p-3 ml-6">Feb 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup_talky.png" style="width: 140px; height: 65px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startuptalky.com/news/yourownroom-agser-buildtech-partnership/" target="_blank">YourOwnROOM Signs Strategic Partnership With Agser BuildTech for Bangalore Residential Projects</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/viestories.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://viestories.com/yourownroom-signs-4-mn-partnership-rushmore-estates/" target="_blank">Proptech Company YourOwnROOM signs a $4 Mn Partnership with Rushmore Estates</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/prop_tech_buzz.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.proptechbuzz.com/news/proptech-company-yourownroom-signs-a-4-million-partnership-with-rushmore-estates-for-their-rs-200-crore-residential-project-in-sarjapur-bangalore" target="_blank">Proptech Company YourOwnROOM signs a $4 Million Partnership with Rushmore Estates for their Rs. 200 Crore Residential Project in Sarjapur, Bangalore</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup_talky.png" style="width: 140px; height: 65px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startuptalky.com/news/yourownroom-agser-buildtech-partnership/" target="_blank">Proptech Company YourOwnROOM Signs a $4 Million Partnership With Rushmore Estates for Their Rs. 200 Crore Residential Project in Sarjapur, Bangalore</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup-story.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startupstorymedia.com/insights-proptech-company-yourownroom-signs-a-4-million-partnership-with-rushmore-estates-for-their-rs-200-crore-residential-project-in-sarjapur-bangalore/" target="_blank">Proptech Company YourOwnROOM signs a $4 Million Partnership with Rushmore Estates for their Rs. 200 Crore Residential Project in Sarjapur, Bangalore</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/realty.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.rprealtyplus.com/allied/yourownroom-signs-4-million-partnership-with-rushmore-estates-113241.html" target="_blank">YourOwnRoom Signs $4 Million Partnership With Rushmore Estates</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup-story.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.youtube.com/watch?v=R9-IKnIbY5c&ab_channel=StartupStoryMedia" target="_blank">How YourOwnRoom is building a Profitable & Scalable Proptech rental and property management business</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>                                                  
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                    2022-23
                  </button>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup_talky.png" style="width: 140px; height: 65px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startuptalky.com/prabhat-kumar-tiwary-success-story/" target="_blank">Prabhat Kumar Tiwary Success Story - The Founder, CEO, and CMD of YourOwnROOM</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jan 2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/realtynxt.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://realtynxt.com/news/mastering-brand-connection-in-real-estate-insights-from-prabhat-tiwary-of-yourownroom" target="_blank">Mastering Brand Connection In Real Estate: Insights From Prabhat Tiwary Of YourOwnRoom</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jun 2022</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup-story.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startupstorymedia.com/slider/yourownroom-transforming-to-being-a-leading-residential-real-estate-asset-management-company-in-india/" target="_blank">YourOwnROOM – Transforming to being a leading Residential Real Estate Asset Management Company in India</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">May 2022</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/startup-story.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://startupstorymedia.com/slider/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/" target="_blank">Prop-Tech is the New Growth Catalyst in Residential Real Estate?</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Apr 2022</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                    2021-22
                  </button>
                </h5>
              </div>
              <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_full-Disrupt-logo.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.businessworld.in/article/Eqaro-Join-Hands-With-YourOwnROOM-To-Offer-Rental-Bonds/19-07-2021-397085/" target="_blank">Eqaro Join Hands With YourOwnROOM To Offer Rental Bonds</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jul 2021</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/ET.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://economictimes.indiatimes.com/industry/services/property-/-cstruction/eqaro-guarantees-partners-with-yourownroom-to-offer-rental-bonds/articleshow/84545719.cms" target="_blank">Eqaro Guarantees partners with YourOwnROOM to offer rental bonds</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jul 2021</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/Free_Press_Logo.png" style="width: 140px; background-color: red;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.freepressjournal.in/business/eqaro-guarantees-partners-with-yourownroom-to-offer-rental-bonds" target="_blank">Eqaro Guarantees partners with YourOwnROOM to offer rental bonds</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jul 2021</span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
              </div>
            </div>
            <div class="card">
                <div class="card-header" id="headingFour">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                      2020-21
                    </button>
                  </h5>
                </div>
                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/TOI.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://timesofindia.indiatimes.com/india/co-living-is-booming-and-millennials-are-to-be-thanked/articleshow/73792002.cms" target="_blank">Co-Living is booming and millennials are to be thanked</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jan 2020</span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    2019-20
                    </button>
                  </h5>
                </div>
                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_siliconindia.gif" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.siliconindia.com/digital-magazine/co-living-startups-december-2019/#page=48" target="_blank">Offering strategically located good quality Co-living and Family managed homes</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Dec 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/Inc42.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://inc42.com/buzz/your-own-room-raises-1-3-mn-seed-funding-to-scale-up-assets/" target="_blank">Proptech YourOwnROOM Raises $1.3 Mn Seed Funding To Scale Up Assets</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Nov 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://inc42.com/buzz/proptech-yourownroom-raises-1-3-mn-seed-funding-to-scale-up-assets/" target="_blank">Proptech startup YourOwnRoom raises $1.3M to scale its co-living business</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Nov 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_full-Disrupt-logo.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://bwdisrupt.businessworld.in/article/YourOwnROOM-has-Raised-1-3-Million-in-Seed-Funding-from-US-Based-Investment-Firm-Lotus-Capital/06-11-2019-178581/" target="_blank">YourOwnROOM has Raised $1.3 Million in Seed Funding from US-Based Investment Firm Lotus Capital</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Nov 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/inventiva.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.inventiva.co.in/trends/yourownroom-secured-1-3m-from-clutch-of-investors/" target="_blank">YourOwnRoom secured $1.3M from clutch of investors</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Nov 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/dealstreetimg.webp" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.dealstreetasia.com/stories/yourownroom-piggyride-161268" target="_blank">Proptech startup YourOwnROOM has secured $1.3 million in a seed funding</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Nov 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.facebook.com/yourstorycom/videos/2356093704666969/" target="_blank">Cut your traffic time by 15mins, stay close to your workplace using YourOwnRoom</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Apr 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>                                        
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingSix">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    2018-19
                    </button>
                  </h5>
                </div>
                <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/Paulwriter.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank">Paul Writer Unveiled Namma Bengaluru Hot Brands 2019!</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/livemint.svg" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.livemint.com/Money/TArIbPohy7pnqyZxkNLRWL/New-real-estate-trends-expected-to-emerge-in-2019.html" target="_blank">New real estate trends expected to emerge in 2019</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jan 2019</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_full-Disrupt-logo.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">YourOwnRoom, a $750K Seed Funded Co-living Home Rental Company, Expands Footprint in Bangalore & Pune</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Oct 2018</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/bangalore-insider.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.bangaloreinsider.com/yourownroom/" target="_blank">YourOwnROOM: An online platform helping people</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Sep 2018</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    2017-18
                    </button>
                  </h5>
                </div>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/bitosa_logo.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.bitosaglobal.org/news/14654" target="_blank">Homes Away from Home: By BITians for BITians</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Sep 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/the-news-min.webp" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.thenewsminute.com/atom/new-breed-startups-wants-solve-problems-house-renters-65949" target="_blank">A new breed of startups wants to solve problems of house renters</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jul 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_full-Disrupt-logo.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>YourOwnROOM Targets to have 10K Tenants and Over $5M Revenue in the Next 3 Years</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Jun 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingEight">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    2016-17
                    </button>
                  </h5>
                </div>
                <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling" target="_blank">YourOwnROOM’s mantra for profitable scaling rides on 3 factors: owner trust, customer delight, and operational excellence</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.youtube.com/watch?v=Uw5AU3WkRiY&ab_channel=YourStory" target="_blank">YourOwnRoom is Championing The Cause Of Comfortable living spaces for singles in India</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_deccan.jpeg" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">YourOwnROOM helps singles find their dwelling</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://yourstory.com/2017/02/yourownroom-online-home-rental" target="_blank">YourOwnROOM dispels the problem of finding a home-away-from-home for singles</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Feb 2017</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_siliconindia.gif" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.siliconindia.com/magazine-articles-in/YourOwnROOM__Redefining_the_rental_landscape_of_urban_India-AWPY511290623.html" target="_blank">YourOwnROOM - Re-defining the rental landscape of urban India</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Oct 2016</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_yourstory.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://yourstory.com/2016/10/yourownroom" target="_blank">This startup aims to address the demand-supply gap in home rentals for singles in India</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Oct 2016</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_siliconindia.gif" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">Startup Of The Year October-2016</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Oct 2016</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/ET.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>Your Own Room Received ETNow Award 2019</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Oct 2016</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="card mb-5">
                <div class="card-header" id="headingNine">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                    Archived
                    </button>
                  </h5>
                </div>
                <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/realtynxt.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://realtynxt.com/news/co-living-yourownroom-raises-1-3-m-in-a-seed-round" target="_blank">Co-living YourOwnROOM raises $1.3 M in a seed round</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/tracxn.svg" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>Real Estate Tech Startup in Bengaluru</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/newsbyte.jpeg" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>YourOwnROOM raises $1.3 million in seed round of funding</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_TheTechPanda.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>YourOwnRoom: Bangalore startup helping millennials</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/owler.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.owler.com/company/yourownroom" target="_blank">Hot In Bangalore Winner 2016</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_indianweb2.png" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>This Bangalore-Based Startup is Solving The Problem</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/crazyengineers.png" style="width: 140px;">
                        </div>
                        <div class="news_texts press_text">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <a href="https://www.crazyengineers.com/threads/yourownroom-founder-prabhat-kumar-tiwary-on-creating-a-win-win-for-homeowners-and-tenants-alike.92293" target="_blank">YourOwnRoom Founder Prabhat Kumar Tiwary</a>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row news_row">
                        <div class="news_img" style="text-align: center;">
                            <img src="assets/images/news/news_prabhatkhabar.jpg" style="width: 140px;">
                        </div>
                        <div class="news_texts">
                            <div class="press_box ml-2">
                                <div class="press_li d-flex justify-content-between align-items-center">
                                    <p>YourOwnRoom Provides Comfortable Staying In Single Room</p>
                                    <span class="badge badge-pill badge-info m-2 p-3">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>  
                  </div>
                </div>
              </div>
          </div>
          </div>
    </div>

    <!-- New PRESS PAGE  on the basis of Financial Years -->
    <!-- <div *ngIf="checkPress == true">        
        <div class="row press-wrapper" style="width: 100%; display: flex; justify-content: space-between;">
                <div class="col-md-3 col-lg-2 col-sm-12 col-12" style="background: #FAFAFA; padding-right: 0;">
                    <div class="fy_sidebar_heading_wrapper">
                        <h1 class="fy_sidebar_heading"> Financial Year </h1>
                    </div>
                    <ul style="padding: 0;">
                        <li class="fyYears-list" *ngFor="let fy of fyYear" >
                            <div class="financialYear-wrapper" (click)="changeFyYear( fy[1], fy[0] )" [ngClass]="{active: fy[0] === selectedIndex}" >  
                                <div style="display: flex; justify-content: center;">      
                                    <div class="financialYear" id="{{ fy[0] }}" >                                     
                                        <fa-icon [icon]="faCalendar" class="fy-icon" ></fa-icon>
                                        <h1 style="margin-bottom: 0; margin-left: 10px;" class="fyYear">    {{ fy[1] }}  </h1>                                    
                                    </div>
                                </div>                
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-9 col-lg-9 col-sm-12 col-12" style="margin: auto;">
                    <h1 class="media-fyYear-title"  > Press & Articles for the Financial Year : {{ selectedYear }}  </h1>
                    <div class="row news_row" *ngFor="let med of mediaList; let odd=odd;let even=even">                  
                        <div class="col-md-4 col-lg-3 news_img" style="text-align: center;">                
                            <img src="{{ med[1].image }}" class="media_img" style="width: 100%;"  >
                        </div>
                        <div class="col-md-8 col-lg-9 news_texts" [ngClass]="{odd: odd, even: even}">
                            <div class="press_box">
                                <ol>
                                    <li class="press_li" *ngFor="let ml of med[1].data" >
                                        <a href="{{ ml.url }}" class="media_headline" target="_blank">  {{ ml.title }} </a>
                                    </li>                        
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                                
    </div>
<!-------------------------------------------- News ends here --------------------------------------->
<!----------------------------------------- Awards and Recognitions here ------------------------------>
<div class="section" *ngIf="checkAwards == true">
    <div class="press_bg">
        <div class="awards_bg">
            <div class="awards_head" style="margin: auto;">
                <h1 style="font-family: 'Montserrat'; font-size: 40px; margin: 0; font-weight: 500; color: black;"> Awards & Recognitions </h1>
            </div>
        </div>
    </div>
    <div class="container-fluid" style="padding: 0;">
        <div class="row award_wrapper">
            <div class="award_desc_top">
                <div>
                    <h1 style="font-weight: 600;"> 
                        <a href="https://yourownroom.com/blog/best-coliving-company-in-south-india-at-india-properties-award-2020/" target="_blank" style="list-style: none; text-decoration: none; color: black;"> 
                            YourOwnROOM Grabs Award For Best Coliving Company In South India at India Properties Award -2020 
                        </a>
                    </h1>
                    <p class="award_span"> It was an honor for YourOwnROOM to get recognized by International Brand Equity in the India Properties Award -2020 as the Best Coliving Company in South India. Award was felicitated by Senior Politician Tanveer Ahmed. Grabbing the award for best Coliving company India in one of reputed India’s National Real Estate Awards platform, it is the proof of the credibility of our company.</p>
                </div>
            </div>
            <div class="award_image">
                <div class="awards_shadow p-4">
                    <img src="https://i0.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/02/1583771584879.jpeg?resize=1080%2C720&ssl=1" style="width: 100%;" class="img-responsive">
                </div>
            </div>
        </div>
        <div class="row award_wrapper">
            <div class="award_image">
                <div class=" awards_shadow p-4">
                    <img src="https://i0.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/01-scaled.jpg?resize=1536%2C1024&ssl=1" style="width: 100%;" class="img-responsive">
                </div>
            </div>
            <div class="award_desc award_desc_2">
                <div class="award_flex">
                    <h1 style="font-weight: 600; text-align: left;"> 
                        <a href="https://yourownroom.com/blog/your-own-room-received-etnow-award-2019/" target="_blank" style="list-style: none; text-decoration: none; color: black;"> 
                            Your Own Room Received ETNow Award – 2019 
                        </a>
                    </h1>
                    <p class="award_span" style="text-align: left;"> YourOwn Room provides millennials shared as well as ready to move accommodations that are available in well-gated and highly-secured societies. Due to their excellent performance in the Real Estate industry, the company has now received the ETNow award for Excellence in Real Estate as the Company of the Year (Co-living Spaces). This is one of the most significant achievements for the company in the Real Estate.</p>
                </div>
            </div>
        </div>
        <div class="row award_wrapper">
            <div class="award_desc">
                <div>
                    <h1 style="font-weight: 600;">
                        <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank" style="list-style: none; text-decoration: none; color: black;">
                            Paul Writer Unveiled Namma Bengaluru Hot Brands 2019!
                        </a> 
                    </h1>
                    <p class="award_span">  Paul Writer recently co-hosted the 4th Edition of Bengaluru Brand Summit and Hot Brands 2019 with Adobe, in partnership with Meltwater, Hindu Business Line, Tata Tele Services, Sitecore, Social Frontier and Iris.</p>
                </div> 
            </div>
            <div class="award_image">
                <div class=" awards_shadow p-4">
                    <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/IMG_5711-1-scaled.jpg?resize=1536%2C1152&ssl=1" style="width: 100%;" class="img-responsive">
                </div>
            </div>
        </div>
    </div>
</div>